import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	open: false,
};

export const tabsSlice = createSlice({
	name: 'drawer',
	initialState: initialState,
	reducers: {
		openDrawer: (state) => {
			state.open = true;
		},
		closeDrawer: (state) => {
			state.open = false;
		},
		resetDrawer: () => initialState,
	},
});

export const { openDrawer, closeDrawer, resetDrawer } = tabsSlice.actions;
export const selectDrawerStatus = (state) => state.drawer.open;
export default tabsSlice.reducer;
